// supabaseClient.js
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://rruehkafubktdoykjfvk.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJydWVoa2FmdWJrdGRveWtqZnZrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTA3Njk4OTksImV4cCI6MjA2NjM0NTg5OX0.jGdrOivmmExWnPaA2HXP4xOfnDhQb1HYhOeh3igIKY8';



// Create and export a single Supabase client instance
export const supabase = createClient(supabaseUrl, supabaseKey);


